module.exports = __webpack_public_path__ + "static/karelys-ruiz-4c1496424dc0843fdf3ecd843bc73c90.jpg";